module.exports = __webpack_public_path__ + "img/24_25.69cb91bc.png";